import React, {useContext} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, Typography, Zoom} from '@mui/material';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {DispatchContext} from '../../../store';
import {SNACKBAR_OPEN} from '../../../reducers';
import * as Yup from 'yup';
import {passwordServices} from '../../../services/InvitationServices';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

const forgetValidateSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required').nullable(),
});

export default function ForgotPassword({open, handleClose}) {
  const dispatch = useContext(DispatchContext);

  const onSubmit = (values, {setSubmitting, resetForm}) => {
    setSubmitting(false);
    passwordServices('post', {...values}).then(response => {
      resetForm();
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Password reset link sent to your email'}
      });
      handleClose(false);
    });
  };
  return (
    <React.Fragment>
      <Formik initialValues={{email: ''}} onSubmit={onSubmit}
              validationSchema={forgetValidateSchema}
      >
        {({
            values,
            errors,
            isSubmitting,
            setFieldValue,
            handleSubmit,
            handleChange,
            handleBlur,
            ...formik
          }) => (
          <Form>
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              onClose={(e) => handleClose(false, e)}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>
                <Typography variant={'h6'} component={'h2'} align={'center'} fontWeight={700}>Forgot
                  Password</Typography>
              </DialogTitle>
              <DialogContent sx={{width: {lg: 450, md: 400, sm: 400, xs: 280}, p: {lg: 6, md: 4, sm: 4, xs: 2}}}>
                <Typography variant={'caption'} component={'h5'} fontWeight={700}>Email Address</Typography>
                <Field component={TextField} variant={'outlined'} name={'email'} label={'Enter your email address'} margin={'dense'}
                       type={'email'}
                       InputLabelProps={{style: {fontSize: 14}}} fullWidth />
                <Button type={'submit'} onClick={handleSubmit} variant={'contained'} sx={{mt: 2, color: '#fff'}}
                        disableElevation fullWidth>submit</Button>
              </DialogContent>
            </Dialog>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}